import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalService } from '../../blocks';
import { UsersPrivilegeSettingsService } from '../../hospitalSetup/users-privilege-setting/users-privilege-settings.service';
import { inTransferBodies, OperationPlaceSettingsService } from './operation-place-settings.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { UserSessionService } from '../../app-user-session.service';
import { NewComingFromComponent } from './new-coming-from/new-coming-from.component';
// import { TranslateService } from '@ngx-translate/core/src/translate.service';

@Component({
  selector: 'app-operation-place-settings',
  templateUrl: './operation-place-settings.component.html',
  styleUrls: ['./operation-place-settings.component.css']
})
export class OperationPlaceSettingsComponent implements OnInit {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  cheackDiscount: boolean;
  inTransferBodies = <inTransferBodies>{};
  inTransferBodiesList: inTransferBodies[] = [];
  //transferBodies: inTransferBodies
  dynamicComponent: any;
  @ViewChild('newComingFrom') popup: any;
  constructor(private _operationPlaceSetting: OperationPlaceSettingsService,
    public translate: TranslateService,
    private _ModalService: ModalService,
    private _userSessionService: UserSessionService

  ) { }

  ngOnInit() {
    this.get();
  }
  // filter() {
  //   if (this.cheackDiscount == true) {
  //     this.inTransferBodiesList = this.inTransferBodiesList.filter(t => t.cshDiscountsCode > 0);
  //   }

  // }
  get() {
    this.inTransferBodies.serial = 0
    this._operationPlaceSetting.getinTransferBodies(this.inTransferBodies)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        this.inTransferBodiesList = res ? res.data : [];
      })
  }
  disabled: number = 0;
  addNewOpertion() {
    this.inTransferBodiesList.unshift(<inTransferBodies>{
      serial: this.inTransferBodiesList.length * -1,
      Status: 1
    });
    this.disabled = 1
  }

  deleteRow(item: inTransferBodies) {

    if (item.serial) {

      this._ModalService.activeDelMes('', '').then(responseOK => {
        if (responseOK) {
          this._operationPlaceSetting.deleteinTransferBodies(item.serial).pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              data => {

                this.get();
              },
              error => console.log(error),
              () => {
                null
              });
        }
      });
    } else {
    }
  }


  edit(item: inTransferBodies) {
    item.Status = 2
    item.rowStatus = +item.rowStatus
  }
  undoAddEdit(row: inTransferBodies, state: number) {
    if (state == 1) {
      this.inTransferBodiesList.splice(this.inTransferBodiesList.indexOf(row), 1)
    } else {
      row.Status = 4
    }
  }

  onRowIconClick(e: number, item: inTransferBodies) {

    switch (e) {
      case 402:

        this.edit(item);
        break;
      case 403:
        this.deleteRow(item);
        break;

      case 7067:
        this.NewComingFrom(item);
        break;

      case 7064:
        this.confirmedBy(item);
        break;

      default:
        console.log('no action');
    }
  }

  onBtnClicked(action: any) {
    if (action == 1) {
      this.save();
    }
  }

  save() {
    let arraySave = this.inTransferBodiesList.filter(x => x.Status > 0)
    arraySave.forEach((el) => {
      el.rowStatus = +el.rowStatus
    })
    this._operationPlaceSetting.addinTransferBodies(arraySave).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => { },
        error => console.log(error),
        () => { this.get(); })
  }

  confirmedBy(item: inTransferBodies) {
    item.confirmedBy = 1
    this._ModalService.activeTranslatedMesg(this.translate.currentLang == 'ar' ? 'هل تريد تأكيد' : 'Do you want to confirm').then(responseOK => {
      if (responseOK) {
        let arraySave = this.inTransferBodiesList.filter(x => x.confirmedBy == 1)
        this._operationPlaceSetting.addinTransferBodies(arraySave).pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((res) => { },
            error => console.log(error),
            () => { this.get(); })
      }
      else {
        item.confirmedBy = 0
      }
    });

  }

  NewComingFrom(item: inTransferBodies) {
    this._ModalService.activeTranslatedMesg(this.translate.currentLang == 'ar' ? 'يرجي اختيار بديل ' : 'Please choose an alternative').then(responseOK => {
      if (responseOK) {

        this.dynamicComponent = NewComingFromComponent;
        this._userSessionService.setSessionKey("updateComingFrom", item.serial)
        this.popup.openModal("PopupLabelPrintComponent", "updateComingFrom", item.serial);

      }
    });
  }
  onSearchClick(_parms: any) {
    this.inTransferBodies = _parms
    this.get();
  }

}
